import { Button, Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CloudDownload } from '@material-ui/icons'
import React, { useState } from 'react'
import IenApi from '../../api/IenApi'
import Loading from '../../customs/Loading/Loading'
import { iMsgAttachment } from '../../types/msg.types'
import { errorIenProcesToast } from '../../utils/errorIenProces'
import { humanFileSize } from '../../utils/humanFileSize'

const useStyles = makeStyles((theme) => ({
  file: {
    margin: '5px 0 !important',
    '&:hover': {
      backgroundColor: '#eee'
    }
  },
  file__content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px !important',
  },
  file__name_wrapper: {
    width: '55%',
    display: 'flex',
    alignItems: 'center',
  },
  file__name_wrapper__name: {
    marginLeft: 5,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  file__download: {
    width: 65
  }
  // file__name_wrapper__icon: {
  //   minWidth: 35,
  // }
}))

interface iFileCard {
  file: iMsgAttachment
  extSystem: string
  extMsgId: string
}

const FileCard = ({ file, extSystem, extMsgId }: iFileCard) => {

  const { fileName, fileSize, isDownloadable, extId } = file

  const [downloading, setDownloading] = useState(false)

  const onClickDownload = async () => {
    setDownloading(true)
    const result = await IenApi.downloadAttachmentExtSys(extSystem, extMsgId, extId)
      .catch(errorIenProcesToast)

    const url = window.URL.createObjectURL(new Blob([result]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName) //or any other extension
    document.body.appendChild(link)
    link.click()
    setDownloading(false)
  }
  const classes = useStyles()
  return (
    <Card className={classes.file}>
      <CardContent className={classes.file__content}>
        <div className={classes.file__name_wrapper}>
          {/*<div className={classes.file__name_wrapper__icon}>*/}
          {/*</div>*/}
          <span className={classes.file__name_wrapper__name}>{fileName}</span>
        </div>
        <div>{fileSize ? humanFileSize(fileSize) : ''}</div>

        <div className={classes.file__download}>
          {downloading ?
            <div style={{ position: 'relative', marginTop: -30, marginLeft: -55 }}>
              <Loading/>
            </div>
            :
            (isDownloadable && extSystem) &&
            <Button variant="contained" color="primary" onClick={onClickDownload}>
              <CloudDownload/>
            </Button>
          }
        </div>

      </CardContent>
    </Card>
  )
}

export default FileCard
